import React, { useState, useEffect } from 'react';
import { Dialog, Box, CircularProgress, FormHelperText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getLocation } from '../../../redux/cart.slice';
import InputField from '../../../Components/Input';
import AutocompleteSelect from '../../../Components/AutocompleteSelect';
import CustomButton from '../../../Components/CustomButton';
import { checkDeliverability } from '../../../redux/riskCenterSlice';

interface LocationUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpdate: (newLocation: LocationOption | undefined) => void;
  currentLocation: string;
  id: string; // oldSetId
  productionName: string;
  setId: string;
  _setName: string;
  locationId?: string;
  branchId?: string;
}

interface SetOption {
  _id: string;
  label: string;
}

export interface LocationOption {
  label: string;
  value: string;
  latitude: number;
  longitude: number;
  locationPurpose: string[];
  address: string;
}

const LocationUpdateModalShift: React.FC<LocationUpdateModalProps> = ({
  isOpen,
  onClose,
  onUpdate,
  currentLocation = '',
  id,
  productionName,
  setId,
  _setName,
  locationId,
  branchId,
}) => {
  const [selectedSet, setSelectedSet] = useState(setId);
  const [selectedNewLocation, setSelectedNewLocation] = useState('');
  const [sets, setSets] = useState<SetOption[]>([]);
  const [newLocations, setNewLocations] = useState<LocationOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  console.log(
    ' = >> >> >> >',
    currentLocation,
    id,
    productionName,
    setId,
    _setName,
    locationId,
  );

  useEffect(() => {
    if (!isOpen) return;

    const fetchData = async () => {
      setLoading(true);

      try {
        // Fetch sets

        setSelectedSet(setId);

        // Fetch locations
        if (setId) {
          const locationData = await getLocation(setId);
          const locationsArray = locationData?.locations || locationData || [];

          const mappedLocations = Array.isArray(locationsArray)
            ? locationsArray.map((item: any) => ({
                label:
                  item.address?.locationName || item.name || 'Unknown Location',
                value: item._id,
                latitude: item.location?.coordinates?.[1],
                longitude: item.location?.coordinates?.[0],
                locationPurpose: item.locationPurpose,
              }))
            : [];

          // Pre-select current set
          const currentLocationExists = mappedLocations.find(
            set => set.value === locationId,
          );

          console.log(
            currentLocationExists,
            'currentLocationExists',
            mappedLocations,
            locationId,
          );
          if (currentLocationExists) {
            setSelectedNewLocation(locationId);
          }
          console.log(mappedLocations, 'mappedLocations');
          setNewLocations(mappedLocations);
        }
      } catch (error) {
        console.error('Error while fetching sets/locations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isOpen, id, setId, _setName]);

  // Fetch locations when selected set changes
  useEffect(() => {
    if (!selectedSet || selectedSet === setId) return;

    const fetchLocations = async () => {
      // setLoading(true);
      try {
        const data = await getLocation(selectedSet);
        const locationsArray = data?.locations || data || [];

        const mappedLocations = Array.isArray(locationsArray)
          ? locationsArray.map((item: any) => ({
              label:
                item.address?.locationName || item.name || 'Unknown Location',
              value: item._id,
              latitude: item.location?.coordinates?.[1],
              longitude: item.location?.coordinates?.[0],
              locationPurpose: item.locationPurpose,
              address: item.address?.addressLine1,
            }))
          : [];

        setNewLocations(mappedLocations);
      } catch (error) {
        console.error('Error fetching locations for selected set:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, [selectedSet, setId]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        onClose();
        setError('');
      }}
      fullWidth
      className="main-modal"
    >
      <div className="modal-dialog md-sm">
        <div className="modal-content">
          <div className="modal-title d-flex align-center flex-between">
            <h2 className="">{productionName}</h2>
            <button
              className="blank-btn"
              aria-label="close"
              onClick={() => {
                onClose();
                setError('');
              }}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="modal-body scroll-body-sm">
            <p className="MuiTypography-body2 mb-15 mt-15 text-text">
              Choose the location you would like to move for your order.
            </p>

            {loading ? (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress />
              </Box>
            ) : (
              <div className="modal-body body-scroll-sm">
                <div className="form-in lg-height mb-12">
                  <AutocompleteSelect
                    id="select-set"
                    labelText="Current Set"
                    placeHolderText="Current Set"
                    disabled={true}
                    options={sets}
                    value={{ _id: setId, label: _setName.toUpperCase() }}
                    labelKey="label"
                  />
                </div>

                <div className="form-in blue-input lg-height mb-12">
                  <InputField
                    requiredField
                    id="name"
                    label="Current Location"
                    name="name"
                    value={currentLocation}
                    disabled
                  />
                </div>

                <div className="form-in lg-height mb-12">
                  <AutocompleteSelect
                    id="Project Type *"
                    labelText="Replace with Current Location"
                    placeHolderText="Replace with Current Location"
                    options={newLocations}
                    value={
                      newLocations.find(
                        loc => loc.value === selectedNewLocation,
                      ) || null
                    }
                    onChange={(event: any, option: any) => {
                      checkDeliverability(
                        {
                          latitude: option?.latitude,
                          longitude: option?.longitude,
                          branchId: branchId,
                        },
                        (data: boolean) => {
                          if (data)
                            setError(
                              'This location is not deliverable. Please choose a different delivery location.',
                            );
                          else setError('');
                        },
                      );
                      setSelectedNewLocation(option?.value || '');
                    }}
                    labelKey="label"
                    isLocationPurpose
                  />
                </div>
                <FormHelperText>
                  <p className={'text-error_500 MuiTypography-subtitle1 fw500'}>
                    {error}
                  </p>
                </FormHelperText>
                {/* <div>{newLocations?.locationPurpose?.join(',')}</div> */}
              </div>
            )}
          </div>

          <div className="modal-actions">
            <div>
              <CustomButton
                id=""
                text="Cancel"
                variant="outlined"
                showIcon={false}
                size="medium"
                className="min_width_btn"
                onClick={() => {
                  onClose();
                  setError('');
                }}
              />
            </div>
            <div>
              <CustomButton
                id=""
                text="Update"
                onClick={() => {
                  onUpdate(
                    newLocations.find(loc => loc.value === selectedNewLocation),
                  );
                  onClose();
                }}
                variant="contained"
                disabled={!selectedSet || !selectedNewLocation || error}
                showIcon={false}
                size="medium"
                className="min_width_btn"
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default LocationUpdateModalShift;
